const uuidv4 = require('uuid/v4');
console.log(uuidv4()); //

export default [
        {
          id: uuidv4(), 
          taskName: "Urgently create a Gatsby (React based) theme for WordPress",
          level: 2
        },
        {
          id: uuidv4(), 
          taskName: "Create a Gridsome (VueJS based) theme for WordPress",
          level: 1
        },
        {
          id: uuidv4(), 
          taskName: "Building a NuxtJS (for front-end) and Laravel-based API",
          level: 2
        },
        {
          id: uuidv4(), 
          taskName: "Deploying to AWS",
          level: 0
        },
         {
          id: uuidv4(), 
          taskName: "Leverage Nodejs",
          level: 2
        }

      ]